import { Box, Radio, Typography } from '@mui/material';

import { url } from 'constants/index';
import RouterLink from 'components/RouterLink/RouterLink';

import { EntityType, MergeableEntity } from './types';

interface GenericEntityHeaderProps {
  entity: MergeableEntity;
  entityType: EntityType;
  isSelected: boolean;
  onRadioChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

const getEntityUrl = (entityType: EntityType, entityId: number): string => {
  const urlMap: Record<EntityType, string> = {
    organizations: url.base_organizations || '/organizations',
    competitions: url.base_competitions || '/competitions',
    seasons: url.base_seasons || '/seasons',
    rounds: url.base_rounds || '/rounds',
    fixtures: url.base_fixtures || '/fixtures',
    persons: url.base_persons || '/persons',
    players: url.base_players || '/players',
    doubles: '/competitors/doubles',
    teams: '/competitors/teams',
    horses: '/competitors/horses',
    venues: url.base_venues || '/venues',
  };

  return `${urlMap[entityType]}/${entityId}`;
};

const formatDate = (dateString: string): string => {
  try {
    return new Date(dateString).toLocaleDateString();
  } catch {
    return dateString;
  }
};

export const GenericEntityHeader = ({
  entity,
  entityType,
  isSelected,
  onRadioChange,
}: GenericEntityHeaderProps) => (
  <Box>
    <Box sx={{ display: 'flex', alignItems: 'center', mb: 1, justifyContent: 'space-between' }}>
      <RouterLink to={getEntityUrl(entityType, entity.id)} style={{ textDecoration: 'none' }}>
        <Typography variant="h6">
          {entity.name} (ID: {entity.id})
        </Typography>
      </RouterLink>
      <Radio
        checked={isSelected}
        onChange={onRadioChange}
        value={entity.id}
        name="real-entity-selection"
        sx={{ mr: 1 }}
      />
    </Box>
    {entity.createdOn && (
      <Typography variant="body2" color="text.secondary" gutterBottom>
        Created: {formatDate(entity.createdOn)}
      </Typography>
    )}
  </Box>
);
